import { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../components/shared/Button';
import useAuthorization from '../hooks/use-authorization';
import useLocalization from '../hooks/use-localization';
import '../resources/css/login.css';
import { useLoginUserMutation } from '../store';

export default function LoginPage() {

    const [login, requestStatus] = useLoginUserMutation();
    const env = useSelector((state) => state.environment);

    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState(env.token);

    const localization = useLocalization();

    if (requestStatus.status === 'fulfilled' && !token) {
        setToken(requestStatus.data.token);
    }

    const onLoginClick = function () {
        const user = {
            login: userName,
            password: password
        };

        login(user);
    };

    const onLogoutClick = function () {
        requestStatus.reset();
        setToken('');
    }

    const onNameChanged = (e) => {
        setUserName(e.target.value);
    };

    const onPasswordChanged = (e) => {
        setPassword(e.target.value);
    };

    const isLoading = requestStatus.status === 'pending';

    useAuthorization(token);

    return (
        <>
            <div className="login">
                {token || env.token ?
                    <div className="login-form">
                        <div className="login-authorized">
                            <i className="fa fa-check-square-o login-icon"></i>
                            <span>{localization.authorized}</span>
                        </div>
                        <div>
                            <Button eventHandler={onLogoutClick}>{localization.logout}</Button>
                        </div>
                    </div>
                    :
                    <div className="login-form">
                        <div>
                            <input type="text" value={userName} onChange={onNameChanged} disabled={isLoading} placeholder={localization.name}></input>
                        </div>
                        <div>
                            <input type="password" value={password} onChange={onPasswordChanged} disabled={isLoading} placeholder={localization.password}></input>
                        </div>
                        <div>
                            {requestStatus.error && requestStatus.error.status === 401 &&
                                <span>{localization.authorizationError}</span>
                            }
                        </div>
                        {isLoading &&
                            <div>
                                <i className="fa fa-spinner spinner" aria-hidden="true"></i>
                            </div>
                        }
                        {!isLoading &&
                            <div>
                                <Button eventHandler={onLoginClick}>{localization.login}</Button>
                            </div>
                        }
                    </div>
                }
            </div>
        </>

    );
};